export var SDK_NAME = 'sentry.javascript.browser';
export var SDK_VERSION = '5.11.2';
//# sourceMappingURL=version.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sentry/browser/esm/version.js
// module id = 364
// module chunks = 0